import apiClient from '@lib/apiClient';
import { type AdminMetricsResponse, AdminMetricsResponseSchema, type ListLicenseViewerQuery, type ListLicenseViewerResponse, ListLicenseViewerResponseSchema } from '@features/admin/domain/admin.schemas';

export const adminService = {
  getAdminMetrics: async (): Promise<AdminMetricsResponse> => {
    const response = await apiClient.get('/admin/metrics');
    return AdminMetricsResponseSchema.parse(response.data);
  },

  listLicenses: async (query: ListLicenseViewerQuery): Promise<ListLicenseViewerResponse> => {
    const response = await apiClient.get('/admin/licenses', {params: query});
    return ListLicenseViewerResponseSchema.parse(response.data);
  },

  deleteCustomer: async (customerId: string): Promise<void> => {
    await apiClient.delete(`/customers/${customerId}`);
  },

  deleteSystem: async (systemId: string): Promise<void> => {
    await apiClient.delete(`/systems/${systemId}`);
  },
};
